export default "__VITE_ASSET__639feb5f__"